import { useState } from "react";
import { api, getToken } from "../lib/api";
import { useFetch } from "../lib/useFetch";

interface Note { id: number; body: string; authorName: string; createdAt: string }
interface Doc { id: number; title: string; category: string; expiryDate: string | null; expired: boolean }

const BASE = import.meta.env.VITE_API_URL ?? "";

export default function HomeContent({ homeId }: { homeId: number }) {
  const notes = useFetch<Note[]>(`/v1/sil/homes/${homeId}/notes`);
  const docs = useFetch<Doc[]>(`/v1/sil/homes/${homeId}/documents`);
  const [note, setNote] = useState("");

  async function addNote(e: React.FormEvent) {
    e.preventDefault();
    if (!note.trim()) return;
    await api(`/v1/sil/homes/${homeId}/notes`, { method: "POST", body: JSON.stringify({ body: note.trim() }) });
    setNote(""); notes.reload();
  }
  async function upload(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    form.append("category", "compliance");
    await fetch(`${BASE}/v1/sil/homes/${homeId}/documents`, {
      method: "POST", headers: { authorization: `Bearer ${getToken()}` }, body: form,
    });
    e.target.value = ""; docs.reload();
  }

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="space-y-2">
        <h2 className="text-lg font-semibold text-ink">Notes</h2>
        <form onSubmit={addNote} className="flex gap-2">
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Record a note…" className="input mt-0 flex-1 text-sm" />
          <button className="btn-secondary px-3 py-1.5 text-sm">Add</button>
        </form>
        {(notes.data ?? []).map((n) => (
          <div key={n.id} className="card p-3 text-sm">
            <p className="text-body">{n.body}</p>
            <p className="text-xs text-faint mt-1">{n.authorName}</p>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-ink">Documents</h2>
          <label className="btn-secondary px-3 py-1.5 text-sm cursor-pointer">
            Upload<input type="file" onChange={upload} className="hidden" />
          </label>
        </div>
        {(docs.data ?? []).map((d) => (
          <div key={d.id} className="card p-3 text-sm flex items-center justify-between">
            <span className="text-body">{d.title} <span className="text-xs text-faint">({d.category})</span></span>
            {d.expiryDate && <span className={`chip ${d.expired ? "bg-red-100 text-red-700" : "bg-slate-100 text-body"}`}>exp {d.expiryDate}</span>}
          </div>
        ))}
        {(docs.data ?? []).length === 0 && <p className="text-sm text-faint">No documents.</p>}
      </div>
    </section>
  );
}
